import { useEffect, useState } from "react";
import api from "./api";
import { displayName } from "./anagConfig";

const norm = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, " ");
const compName = (c) => (typeof c === "string" ? c : (c?.denominazione || c?.nome || c?.name || c?.label || ""));

// Associa professionista e compagnia tramite ID univoco della compagnia.
// Carica l'anagrafica compagnie e costruisce una mappa "variante nome -> ID compagnia",
// così cliente/controparte e professionista vengono confrontati per ID anche se i nomi salvati differiscono.
// Fallback al confronto per nome normalizzato per dati legacy o compagnie non in anagrafica.
export default function useCompagniaMatcher(enabled = true) {
  const [map, setMap] = useState(null);
  useEffect(() => {
    if (!enabled || map) return;
    api.get("/anagrafiche/compagnie").then(({ data }) => {
      const m = {};
      (data || []).forEach((c) => {
        if (!c.id) return;
        [displayName(c), c.denominazione, c.ragione_sociale, c.nome, c.compagnia, c.codice_ivass, c.codice_ania].forEach((n) => {
          const k = norm(n);
          if (k && !(k in m)) m[k] = c.id;
        });
      });
      setMap(m);
    }).catch(() => setMap({}));
  }, [enabled, map]);

  const resolveId = (name) => (map ? map[norm(compName(name))] : undefined);

  const inCompagnia = (recCompagnie, compagnia) => {
    if (!compagnia) return false;
    const list = Array.isArray(recCompagnie)
      ? recCompagnie
      : (Array.isArray(recCompagnie?.compagnie) ? recCompagnie.compagnie : (Array.isArray(recCompagnie?.compagnie_multi) ? recCompagnie.compagnie_multi : []));
    const targetId = resolveId(compagnia);
    if (targetId && list.some((c) => resolveId(c) === targetId)) return true;
    const target = norm(compagnia);
    return list.some((c) => norm(compName(c)) === target);
  };

  return { resolveId, inCompagnia, ready: !!map };
}
